<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, vodafoneLabBasicMixin],
  data: function () {
    return {};
  },
  mounted() {
    this.registerAnimation();
  },
  computed: { },
  methods: {
    expandUrl: Fandom.expandUrl,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTarget: Fandom.getTarget,
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType"
    class="inview_animate"
    v-if="isContentVisibleToUser()" 
    list-keyopints-tile-component
    :id="content.name"
  >
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container">
      <div class="row my-4 my-md-5" v-if="content.title">
        <div class="col-12 text-center">
          <h4 class="my-3">{{content.title}}</h4>
        </div>
      </div>
      <div class="row my-4 my-md-5">
        <div class="col-12 d-flex justify-content-center align-items-center flex-wrap">
          <div class="p-4" v-for="(keypoint, index) in content.keypoints" :key="`keypoints-${index}`">
            <a :href="keypoint.url.url" :target="getTarget(keypoint.url)" v-if="keypoint.url">
              <img :src="keypoint.logo.url" v-if="keypoint.logo" class="logo">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-keyopints-tile-component] {

  .logo {
    max-height: 2.75rem;
    height: auto;
    width: auto;
    max-width: 8.5rem;
  }

}

</style>